// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5e644d04","455":"11773e3d"}[chunkId] + ".chunk.js";
};